// Single source of truth for every external destination used across the site.
// Do not alter these URLs — they are the organization's real destinations.

export const externalLinks = {
  getConnectedForm:
    'https://docs.google.com/forms/d/e/1FAIpQLSfeuu9P3ouXzn_Uzg5k8ZzNyGFU2T6E8PNpN8jn8A0DkHW-3g/viewform',
  instagram: 'https://www.instagram.com/ucfbcm/',
  discord: 'https://discord.gg/3eQH4qEese',
  knightConnect:
    'https://knightconnect.campuslabs.com/engage/organization/baptistcollegiateministries',
  /** Current-year album: "2026–27 BCM Photos". */
  photoAlbum:
    'https://drive.google.com/drive/folders/1r3AnZsKyRN_AdIi6LcppwV315l_ITxH6?usp=sharing',
  /** Historical album: "Public BCM Photos" (Fall 2025 + Spring 2026). */
  pastPhotoAlbum:
    'https://drive.google.com/drive/folders/1MiP_wflUB3I0Yfaij0Bus9sfvwI6S3WY?usp=drive_link',
  studentUnion: 'https://www.ucf.edu/location/student-union/',
  capeFloridaBallroom: 'https://studentunion.ucf.edu/cape-florida-ballroom/',
  email: 'mailto:ucfbcm@ucfbcm.com',
  // Existing verified giving page on the current site.
  // TODO: Confirm the long-term giving processor and final destination with BCM
  // leadership before production migration.
  currentGivingPage: 'https://ucfbcm.com/give/',
} as const

export const emailAddress = 'ucfbcm@ucfbcm.com'

export const meeting = {
  summary: 'Thursdays at 7:30 PM during the school year',
  location: 'Most weeks: UCF Student Union, 3rd Floor • Cape Florida Ballroom, Room 316',
  clarification:
    'Check the Events page or Instagram before attending for the latest location.',
} as const

/** Shown wherever a schedule is displayed, so the site never implies it is exhaustive. */
export const scheduleDisclaimer =
  'Schedules may change during the semester. Check BCM’s official channels for the latest details.'

/** The three official student channels, in the order they are always presented. */
export const officialChannels = [
  {
    id: 'instagram',
    title: 'Follow on Instagram',
    copy: 'Event announcements, reminders, photos, and weekly updates',
    href: externalLinks.instagram,
  },
  {
    id: 'knightconnect',
    title: 'View KnightConnect',
    copy: 'Official UCF organization information and posted events',
    href: externalLinks.knightConnect,
  },
  {
    id: 'discord',
    title: 'Join the Discord',
    copy: 'Community conversations and current announcements',
    href: externalLinks.discord,
  },
] as const

export type NavItem = {
  label: string
  to: string
  children?: { label: string; to: string }[]
}

export const primaryNav: NavItem[] = [
  { label: 'Home', to: '/' },
  { label: 'Events', to: '/events' },
  { label: 'About', to: '/about' },
  { label: 'Photos', to: '/photos' },
  {
    label: 'Resources',
    to: '/local-churches',
    children: [{ label: 'Local Churches', to: '/local-churches' }],
  },
  { label: 'Give', to: '/give' },
]

export const allRoutes: { label: string; to: string }[] = [
  { label: 'Home', to: '/' },
  { label: 'Events', to: '/events' },
  { label: 'About', to: '/about' },
  { label: 'Photos', to: '/photos' },
  { label: 'Local Churches', to: '/local-churches' },
  { label: 'Connect', to: '/connect' },
  { label: 'Give', to: '/give' },
]
